// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import 'whatwg-fetch'

// styles
// import './favicons'
import 'styles/index.scss'

// react stuff
import React from 'react'
import ReactDOM from 'react-dom'
import Routes from 'routes'
import { HashRouter as Router } from 'react-router-dom'
import { AuthProvider } from 'components/Auth'
import { PopoverProvider } from 'components/PopoverContext'
import { TooltipProvider } from 'components/TooltipContext'
import ConnectedLoader from 'components/ConnectedLoader'

import {
  GlobalErrorBoundary,
  ReduxNotifications,
} from 'components'

// redux stuff
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import * as reducers from 'redux/modules'

import {
  reducer as notifications,
} from 'react-notification-system-redux'

import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
} from 'redux'

import {
  reducer as formReducer,
} from 'redux-form'

// AWS Amplify stuff
import Amplify from 'aws-amplify'
import awsConfig from 'aws-exports'
import 'intersection-observer'

// Polyfill for IE11 which allows us to use reactstrap Carousel
// Carousel is the only component which uses BS custom events
// but without this it will crash the application.
// https://github.com/reactstrap/reactstrap/issues/799
(function () {
  function CustomEvent (event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined }
    var evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }

  CustomEvent.prototype = window.Event.prototype

  window.CustomEvent = CustomEvent
})()

Amplify.configure(awsConfig)

const reducer = combineReducers({
  ...reducers,
  form: formReducer,
  notifications,
})

const store = createStore(
  reducer,
  undefined,
  compose(
    applyMiddleware(thunk),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
  )
)

ReactDOM.render(
  <Provider store={store}>
    <AuthProvider>
      <GlobalErrorBoundary>
        <TooltipProvider>
          <PopoverProvider>
            <Router>
              <Routes/>
            </Router>
            <ReduxNotifications />
          </PopoverProvider>
        </TooltipProvider>
      </GlobalErrorBoundary>
    </AuthProvider>
    <ConnectedLoader />
  </Provider>,
  document.getElementById('app')
)
